export const PAYMENT_REMINDER_DEFAULT_INTERVAL = 2;
export const PAYMENT_REMINDER_DEFAULT_TIMES = 2;
